import styled from 'styled-components';
import { breakpoints, colors, text, verticalGutter } from '../../styles';
import Slider from 'react-slick';

// Section needs margin top or else it overlaps with the 3 category header due to negative margin from semantic UI.
export default styled(Slider)`
  margin-bottom: ${verticalGutter}rem;

  /* add/overwrite slick styles */
  .slick {
    &-slide {
      padding: 0.5rem 1rem;
      @media only screen and (min-width: ${breakpoints.computer}) {
        height: auto;
      }

      > div {
        width: 100%;
      }
    }

    &-track {
      display: flex;
      height: 100%;
    }

    &-dots {
      margin: 0;
      padding: 0;
      list-style: none;
      text-align: center;

      button {
        border: 0;
        background: transparent;
        display: block;
        outline: none;
        line-height: 0;
        font-size: 0;
        color: transparent;
        padding: 0.5rem;
        cursor: pointer;
        text-align: center;

        &:hover,
        &:focus {
          outline: none;
        }

        &:before {
          content: '\\2022';
          font-size: 2.5rem;
          line-height: 1;
          text-align: center;
          color: ${colors.textColor};
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }
      }

      > li {
        display: inline-block;
        opacity: 0.5;
        &:hover,
        &:focus {
          opacity: 1;
        }
        &.slick-active {
          opacity: 1;
          button:before {
            color: ${colors.primary};
          }
        }
      }
    }

    &-arrow {
      position: absolute;
      top: ${verticalGutter / 2}rem;
      z-index: 9;
      border: none;
      background: transparent;
      padding: 0;
      color: ${colors.primary};
      font-weight: bold;
      cursor: pointer;
      z-index: 0;

      &:before,
      &:after {
        content: '';
        width: 0.6em;
        height: 0.6em;
        display: inline-block;
        vertical-align: middle;
        border: 1px solid ${colors.primary};
        transform: rotate(45deg) translateX(-0.1em);
        margin: 0.25em;
        border-width: 1px 1px 0 0;
      }

      &,
      &:before {
        transition: all 0.3s ease;
      }
    }

    &-next {
      left: auto;
      right: ${verticalGutter / 2}rem;
      &:before {
        display: none;
      }
      @media only screen and (min-width: ${breakpoints.tablet}) {
        right: ${verticalGutter * 2}rem;
      }
    }

    &-prev {
      position: relative;
      left: ${verticalGutter / 2}rem;
      margin: ${verticalGutter / 2}rem 0 ${verticalGutter / 4}rem;
      @media only screen and (min-width: ${breakpoints.tablet}) {
        left: ${verticalGutter * 2}rem;
      }
      &:after {
        display: none;
      }
      &:before {
        transform: rotate(45deg) translateY(-0.2em) scale(-1);
      }
    }
    /* disabled state */
    &-disabled {
      cursor: default;
      &,
      &:hover {
        &,
        &:before {
          border-color: #9b9b9b;
        }
      }
    }
  }

  /* namespace'd styles */
  .streamslider {
    &__img {
      margin: 0 0 ${verticalGutter / 2}rem;
      img {
        max-width: 100%;
        margin: 0 auto;
      }
    }

    &__content {
      padding: ${verticalGutter / 2}rem;
      font-size: ${text.medium};
      h2,
      h3,
      h4,
      h5,
      h6 {
        color: ${colors.darkBlack};
      }
      h3,
      h4,
      h5,
      h6 {
        margin-bottom: 0.1em;
      }
    }
  }

  &.streamslider {
    &--align {
      .slick-slide {
        > div {
          height: 100%;
        }
      }
    }

    /* used specifically for CompareResults & SalesToolResults */
    &--stretch {
      margin: 0 ${verticalGutter / -2}rem;

      @media only screen and (min-width: ${breakpoints.tablet}) {
        margin-left: ${verticalGutter * -1}rem;
        margin-right: ${verticalGutter * -1}rem;
        min-height: calc(100% - 0.5rem);
      }

      @media only screen and (min-width: ${breakpoints.computer}) {
        /* slick added attribute: means carousel enabled */
        overflow: hidden;
        display: flex;
        margin-left: ${verticalGutter / -2}rem;
        margin-right: ${verticalGutter / -2}rem;
        &[dir] {
          display: block;
        }
      }

      .slick {
        @media only screen and (min-width: ${breakpoints.tablet}) {
          &-list {
            width: 100%;
          }
          &-initialized {
            .slick-slide {
              display: flex;
            }
          }
          &-dots {
            position: absolute;
            right: 0;
            top: -2.25rem;
          }
        }

        @media only screen and (min-width: ${breakpoints.computer}) {
          &-track {
            width: 100% !important;
          }
        }
      }
    }
  }
`;
